angular.module('bmsApp.merrymaids').factory('MMHouseTemplateSvc', function (CRUDSvc) {

	return {

		index: function(params) {
            return CRUDSvc.get('api/merrymaids/house-template', params);
		},
		options: function (params) {
			return CRUDSvc.get('api/merrymaids/house-template/options', params);
		},
		save: function(params) {
			return CRUDSvc.post('api/merrymaids/house-template/save', params);
		},
		read: function(params) {
			return CRUDSvc.get('api/merrymaids/house-template/read', params);
		},
		delete: function(params) {
			return CRUDSvc.get('api/merrymaids/house-template/delete', params);
		},
		roomType: {
            options: function (params) {
                return CRUDSvc.get('api/merrymaids/room-type/options', params);
            }
		}
	}

});
